/**
 * ms-motivwahl · Messe-Shop24
 * Bildauswahl der Standardmotive (snippets/ms-motivwahl.liquid).
 *
 * - Zeigt die Auswahl nur bei Varianten mit „Standardmotiv“ (JSON [data-msmw-varianten]).
 * - Filtert nach der Format-Option der Variante (hoch/quer), sonst alle Motive.
 * - Schreibt properties[Motiv] / properties[Weihnachtsgruß] und hängt die Felder per
 *   form-Attribut an das Produktformular (Canopy liest FormData des Formulars).
 * - Sperrt „In den Warenkorb“ (Klick + Submit, Capture-Phase), solange kein Motiv gewählt ist.
 * - Reagiert auf Canopys on:variant:change und auf das Quick-Add-Fenster.
 * - Benennt die Download-Links im Zusatzleistungen-Kasten (Motivübersicht/Druckdatenblatt).
 */
(function () {
  if (window.msMotivwahl) return;
  window.msMotivwahl = true;

  const $ = (root, sel) => root.querySelector(sel);
  const $$ = (root, sel) => Array.from(root.querySelectorAll(sel));

  /** Produktformular zur Box: im Quick-Add-Fenster das dortige, sonst das der Hauptseite. */
  function formular(b) {
    const qa = b.closest('quick-add-drawer');
    if (qa) return $(qa, 'form.js-product-form-main');
    return $$(document, 'form.js-product-form-main').find((f) => !f.closest('quick-add-drawer')) || null;
  }

  function variantenDaten(b) {
    if (!b._msmwVarianten) {
      try { b._msmwVarianten = JSON.parse($(b, '[data-msmw-varianten]').textContent); } catch (e) { b._msmwVarianten = {}; }
    }
    return b._msmwVarianten;
  }

  function aktuelleVariante(b) {
    const form = formular(b);
    const id = form && $(form, '[name="id"]');
    return id ? String(id.value) : '';
  }

  function variante(b) {
    return variantenDaten(b)[aktuelleVariante(b)] || { std: false, logo: false, format: '' };
  }

  function kacheln(b) { return $$(b, '[data-msmw-motiv]'); }
  function gewaehlteKachel(b) { return $(b, '[data-msmw-motiv][aria-checked="true"]'); }

  /** Felder mit dem Formular verknüpfen und befüllen (disabled = nicht im FormData). */
  function felderSetzen(b) {
    const form = formular(b);
    const v = variante(b);
    const k = gewaehlteKachel(b);
    const motiv = $(b, '[data-msmw-feld="motiv"]');
    const gruss = $(b, '[data-msmw-feld="gruss"]');
    // getAttribute statt form.id: das Feld name="id" im Formular überdeckt die Eigenschaft .id
    const formId = form && form.getAttribute('id');
    [motiv, gruss].forEach((f) => { if (formId) f.setAttribute('form', formId); });

    const aktiv = v.std && k && !k.hidden;
    motiv.value = aktiv ? k.dataset.titel : '';
    motiv.disabled = !aktiv;

    const mitGruss = aktiv && k.dataset.gruss === '1';
    const sprache = $(b, '[data-msmw-gruss-wert]:checked');
    gruss.value = mitGruss && sprache ? sprache.value : '';
    gruss.disabled = !mitGruss;
    $(b, '[data-msmw-gruss]').hidden = !mitGruss;
  }

  function anzeigeWahl(b) {
    const k = gewaehlteKachel(b);
    const wahl = $(b, '[data-msmw-wahl]');
    const liste = $(b, '[data-msmw-liste]');
    if (k && !k.hidden && !b._msmwOffen) {
      const vorschau = $(k, 'img');
      $(wahl, '[data-msmw-wahl-bild]').src = (vorschau && vorschau.currentSrc) || k.dataset.klein;
      $(wahl, '[data-msmw-wahl-bild]').alt = k.dataset.titel;
      $(wahl, '[data-msmw-wahl-code]').textContent = k.dataset.code;
      $(wahl, '[data-msmw-wahl-name]').textContent = k.dataset.name;
      wahl.hidden = false;
      liste.hidden = true;
    } else {
      wahl.hidden = true;
      liste.hidden = false;
    }
  }

  /** Format- und Suchfilter anwenden. */
  function filtern(b) {
    const v = variante(b);
    const such = ($(b, '[data-msmw-suche]').value || '').trim().toLowerCase();
    let sichtbar = 0;
    kacheln(b).forEach((k) => {
      const passtFormat = !v.format || k.dataset.format === v.format;
      const passtSuche = !such || k.dataset.code.toLowerCase().includes(such) || k.dataset.name.toLowerCase().includes(such);
      k.hidden = !(passtFormat && passtSuche);
      if (!k.hidden) sichtbar += 1;
    });
    $(b, '[data-msmw-leer]').hidden = sichtbar > 0;

    // Gewähltes Motiv passt nicht mehr zum Format → Auswahl aufheben
    const k = gewaehlteKachel(b);
    if (k && v.format && k.dataset.format !== v.format) waehlen(b, null);

    const anzahl = kacheln(b).filter((x) => !v.format || x.dataset.format === v.format).length;
    const formatText = v.format === 'hoch' ? ' im Hochformat' : v.format === 'quer' ? ' im Querformat' : '';
    $(b, '[data-msmw-anzahl]').textContent = `${anzahl} Standardmotive${formatText}`;
  }

  function waehlen(b, k) {
    kacheln(b).forEach((x) => {
      x.setAttribute('aria-checked', x === k ? 'true' : 'false');
      x.tabIndex = x === k ? 0 : -1;
    });
    if (k) {
      b._msmwOffen = false;
      fehler(b, false);
    }
    felderSetzen(b);
    anzeigeWahl(b);
  }

  function fehler(b, an) {
    $(b, '[data-msmw-fehler]').hidden = !an;
    b.classList.toggle('msmw--fehler', an);
  }

  function aktualisieren(b) {
    const v = variante(b);
    b.hidden = !v.std;
    $(b, '[data-msmw-hinweis-logo]').hidden = !v.logo;
    if (!v.std) fehler(b, false);
    filtern(b);
    felderSetzen(b);
    anzeigeWahl(b);
  }

  /** Box zur Warenkorb-Aktion finden (Formular → Box im selben Bereich). */
  function boxZuFormular(form) {
    if (!form) return null;
    const qa = form.closest('quick-add-drawer');
    const root = qa || document;
    return $$(root, '[data-msmw]').find((b) => (qa ? true : !b.closest('quick-add-drawer'))) || null;
  }

  function pruefen(e, form) {
    const b = boxZuFormular(form);
    if (!b || !variante(b).std || gewaehlteKachel(b)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    fehler(b, true);
    b._msmwOffen = true;
    anzeigeWahl(b);
    b.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  // Warenkorb-Klick (auch Sticky-Leiste mit form-Attribut) und Submit abfangen
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[name="add"]');
    if (!btn) return;
    const form = btn.form || btn.closest('form');
    if (form && form.classList.contains('js-product-form-main')) pruefen(e, form);
  }, true);
  document.addEventListener('submit', (e) => {
    if (e.target.classList && e.target.classList.contains('js-product-form-main')) pruefen(e, e.target);
  }, true);

  document.addEventListener('click', (e) => {
    const zoom = e.target.closest('[data-msmw-zoom]');
    if (zoom) {
      e.stopPropagation();
      const k = zoom.closest('[data-msmw-motiv]');
      const b = k.closest('[data-msmw]');
      const d = document.getElementById(`${b.id}-zoom`);
      if (!d) return;
      d._msmwKachel = k;
      $(d, '[data-msmw-zoom-bild]').src = k.dataset.gross;
      $(d, '[data-msmw-zoom-bild]').alt = k.dataset.titel;
      $(d, '[data-msmw-zoom-code]').textContent = k.dataset.code;
      $(d, '[data-msmw-zoom-name]').textContent = k.dataset.name;
      if (typeof d.showModal === 'function') d.showModal();
      return;
    }
    const zoomWahl = e.target.closest('[data-msmw-zoom-waehlen]');
    if (zoomWahl) {
      const d = zoomWahl.closest('dialog');
      const k = d._msmwKachel;
      if (k) waehlen(k.closest('[data-msmw]'), k);
      d.close();
      return;
    }
    const zu = e.target.closest('[data-msmw-zu]');
    if (zu) { zu.closest('dialog').close(); return; }
    const dlg = e.target.matches && e.target.matches('[data-msmw-zoom-dialog]') ? e.target : null;
    if (dlg) { dlg.close(); return; } // Klick auf den Hintergrund

    const kachel = e.target.closest('[data-msmw-motiv]');
    if (kachel) { waehlen(kachel.closest('[data-msmw]'), kachel); return; }

    const aendern = e.target.closest('[data-msmw-aendern]');
    if (aendern) {
      const b = aendern.closest('[data-msmw]');
      b._msmwOffen = true;
      anzeigeWahl(b);
      const k = gewaehlteKachel(b);
      if (k) k.scrollIntoView({ block: 'nearest' });
    }
  });

  // Tastatur: Enter/Leertaste wählt, Pfeiltasten wandern durch die sichtbaren Kacheln
  document.addEventListener('keydown', (e) => {
    const k = e.target.closest && e.target.closest('[data-msmw-motiv]');
    if (!k || e.target.closest('[data-msmw-zoom]')) return;
    const b = k.closest('[data-msmw]');
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); waehlen(b, k); return; }
    const pfeile = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
    if (!(e.key in pfeile)) return;
    e.preventDefault();
    const sichtbar = kacheln(b).filter((x) => !x.hidden);
    const ziel = sichtbar[(sichtbar.indexOf(k) + pfeile[e.key] + sichtbar.length) % sichtbar.length];
    if (ziel) { kacheln(b).forEach((x) => { x.tabIndex = x === ziel ? 0 : -1; }); ziel.focus(); }
  });

  document.addEventListener('input', (e) => {
    if (e.target.matches('[data-msmw-suche]')) filtern(e.target.closest('[data-msmw]'));
  });
  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-msmw-gruss-wert]')) felderSetzen(e.target.closest('[data-msmw]'));
  });

  // Canopy: Variantenwechsel
  document.addEventListener('on:variant:change', () => {
    setTimeout(() => $$(document, '[data-msmw]').forEach(aktualisieren), 60);
  });

  // Nach dem Hinzufügen bleibt die Auswahl stehen (gleiches Motiv in anderer Auflage möglich).

  /**
   * Download-Links im Zusatzleistungen-Kasten ([data-mszl-dd]) benennen: Die Motivübersicht heißt
   * „Motivübersicht (alle Motive)“, das Druckdatenblatt daneben ohne „Teil N“. Liquid rendert das
   * schon so; ms-zusatzleistungen.js baut die Links beim Variantenwechsel aber mit „Teil N“ neu –
   * daher hier per MutationObserver nachziehen.
   */
  function downloadsBenennen(box) {
    const links = $$(box, 'a');
    const mitMotiv = links.some((a) => a.href.includes('motivuebersicht'));
    if (!mitMotiv) return;
    links.forEach((a) => {
      const text = a.href.includes('motivuebersicht') ? 'Motivübersicht (alle Motive)' : 'Druckdatenblatt';
      const knoten = Array.from(a.childNodes).filter((n) => n.nodeType === 3);
      const ist = knoten.map((n) => n.textContent).join('').trim();
      if (ist === text) return;
      knoten.forEach((n) => n.remove());
      a.appendChild(document.createTextNode(text));
    });
  }
  function downloadsBeobachten(root) {
    $$(root, '[data-mszl-dd]').forEach((box) => {
      downloadsBenennen(box);
      if (box.dataset.msmwBeobachtet) return;
      box.dataset.msmwBeobachtet = '1';
      new MutationObserver(() => downloadsBenennen(box)).observe(box, { childList: true });
    });
  }

  function init() {
    $$(document, '[data-msmw]').forEach(aktualisieren);
    downloadsBeobachten(document);
    const ziel = document.querySelector('quick-add-drawer .js-product-details');
    if (ziel && !ziel.dataset.msmwBeobachtet) {
      ziel.dataset.msmwBeobachtet = '1';
      new MutationObserver(() => {
        $$(ziel, '[data-msmw]').forEach(aktualisieren);
        downloadsBeobachten(ziel);
      }).observe(ziel, { childList: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
